import { useServicesQuery } from '@/services/api';
import type { UseTasksOptions } from '../types';
import { transformBackfill } from '../utils/task-transform';

export function useTasks(options: UseTasksOptions) {
  const { workspaceId, continuation, limit, enabled = true, state, type, refetchInterval } = options;

  const { data, isLoading, refetch, dataUpdatedAt } = useServicesQuery(
    'getBackfills',
    {
      params: { environment_id: workspaceId ?? 0 },
      query: {
        continuation: continuation ?? undefined,
        state: state ?? undefined,
        type: type ?? undefined,
      },
    },
    {
      enabled: enabled && workspaceId != null && workspaceId > 0,
      refetchInterval,
      select: (queryData) => ({
        ...queryData,
        backfills: (queryData?.backfills ?? []).map(transformBackfill),
      }),
    },
  );

  // Apply limit after select to avoid unnecessary refetches when limit changes
  const tasks = (limit != null && limit > 0 ? data?.backfills.slice(0, limit) : data?.backfills) ?? [];

  return {
    tasks,
    meta: data?.meta,
    isLoading,
    refetch,
    dataUpdatedAt,
  };
}
